import classnames from 'classnames';
import React from 'react';

interface IButtonProps {
    children: React.ReactNode;
    onClick?: (e: React.MouseEvent) => void;
    size: ButtonSize;
    variant?: ButtonVariant;
    loaderPlacement?: ButtonLoaderPlacement;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    loading?: boolean;
    className?: string;
    target?: string;
    tabIndex?: number | undefined;
}

export const Button = (props: IButtonProps) => {
    const buttonClassNames = classnames(
        'Button',
        `Button--${ButtonSize[props.size]}`,
        `Button--${ButtonVariant[props.variant || ButtonVariant.Primary]}`,
        `Button--Loader${ButtonLoaderPlacement[props.loaderPlacement || ButtonLoaderPlacement.Left]}`,
        props.loading && 'Button--Loading',
        props.className
    );

    const onClick = (e: React.MouseEvent) => {
        if (!props.loading && props.onClick) {
            props.onClick(e);
        }
    };

    return (
        <button className={buttonClassNames} onClick={onClick} disabled={props.disabled} type={props.type} tabIndex={props.tabIndex}>
            {props.loading && props.loaderPlacement !== ButtonLoaderPlacement.Right && <div className="Button__Loader" />}
            {props.children}
            {props.loading && props.loaderPlacement === ButtonLoaderPlacement.Right && <div className="Button__Loader" />}
        </button>
    );
};

export enum ButtonLoaderPlacement {
    Left,
    Right
}

export enum ButtonVariant {
    Primary,
    Secondary,
    Tertiary,
    Quaternary,
    Text,
    Link,
    PhilPrimary
}

export enum ButtonSize {
    XXSmall,
    XSmall,
    Small,
    Medium,
    Large
}
